export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxbl8c5ijTjQJElti5.41d6a258.woff2";